export default "__VITE_ASSET__C9wJ8Rz5__"